import React from 'react';
import classNames from 'classnames';

const NavigationItemsGroup = ({ children }) => {
  return <div className={classNames('c-nav__items-group')}>{children}</div>;
};

export default NavigationItemsGroup;
